import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { HexMark, Icon, monogram } from '@hive/ui';
import { useAuth } from '../auth/AuthContext';
import { initials } from '../lib/format';

/** Venue identity on the left, pair / user / sign out on the right. */
export function VenueHeader({ name, context, extra }: { name: string; context?: ReactNode; extra?: ReactNode }) {
  const { user, signOut } = useAuth();
  return (
    <header className="k-header">
      <div className="k-header__venue">
        <HexMark label={monogram(name)} size={44} tone="deep" />
        <div className="k-header__titles">
          <Link to="/" className="k-header__name">
            {name}
          </Link>
          {context && <span className="k-header__context">{context}</span>}
        </div>
      </div>
      <div className="k-header__actions">
        {extra}
        {user?.permissions.includes('screens.setup') && (
          <Link to="/setup" className="hv-btn hv-btn--icon" aria-label="Screens and areas" title="Set up screens and areas">
            <Icon name="settings" size={20} />
          </Link>
        )}
        <Link to="/pair" className="hv-btn hv-btn--icon" aria-label="Pair a screen" title="Pair a new TV screen">
          <Icon name="pair" size={20} />
        </Link>
        {user && (
          <span className="k-user">
            <span aria-hidden="true" className="k-user__avatar">
              {initials(user.name)}
            </span>
            <span>
              <span className="k-user__name">{user.name}</span>
              {user.title ? ` · ${user.title}` : ''}
            </span>
          </span>
        )}
        <button type="button" className="hv-btn hv-btn--secondary hv-btn--sm k-signout" onClick={signOut}>
          Sign out
        </button>
      </div>
    </header>
  );
}
